var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.453,
    height: 38.795,
    viewBox: "0 0 39.453 38.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "towel",
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5622",
    "data-name": "Group 5622",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15058",
    "data-name": "Path 15058",
    d: "M37.48,5.973h-.939a3.38,3.38,0,0,0-.684-1.014A3.3,3.3,0,0,0,33.535,4H8.548A4.6,4.6,0,0,0,4.785,5.973H1.973a1.973,1.973,0,0,0,0,3.945H3.945v32.22A.658.658,0,0,0,4.6,42.8H30.9a.658.658,0,0,0,.658-.658V40.823h4.6a.658.658,0,0,0,.658-.658V9.918h.658a1.973,1.973,0,1,0,0-3.945ZM4.125,7.342c-.039.135-.066.275-.091.414-.013.07-.032.138-.042.208a4.675,4.675,0,0,0-.046.638H1.973a.658.658,0,0,1,0-1.315H4.137C4.131,7.306,4.13,7.324,4.125,7.342ZM30.247,41.48H5.26V36.22H30.247Zm0-6.575H5.26v-2.63H30.247Zm.6-29.5c-.04.057-.077.116-.113.176-.053.087-.1.177-.148.27-.03.066-.059.126-.086.191-.016.041-.038.078-.053.118l0,.005a.657.657,0,0,0-.1.138.612.612,0,0,0-.049.072.648.648,0,0,0-.055.258V30.96H5.26V8.6a3.183,3.183,0,0,1,.445-1.644A3.288,3.288,0,0,1,8.548,5.315H30.9C30.884,5.342,30.869,5.373,30.85,5.4Zm1.226.56a1.941,1.941,0,0,1,.272-.248c.026-.02.055-.035.081-.053a1.931,1.931,0,0,1,.239-.14c.038-.019.077-.036.116-.051a1.9,1.9,0,0,1,.251-.084c.038-.01.076-.022.114-.029a1.951,1.951,0,0,1,.384-.041,1.978,1.978,0,0,1,1.391.572c.027.028.055.057.079.085H32.067Zm3.431,33.547H31.562V9.918h3.945ZM37.48,8.6H31.562V7.288H37.48a.658.658,0,0,1,0,1.315Z",
    transform: "translate(0 -4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowel);
export default __webpack_public_path__ + "static/media/towel.a7b5d9c4fe3bf578e99405d5cc6308d2.svg";
export { ForwardRef as ReactComponent };